(function () {
  function parse(el, fallback) {
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return fallback;
    }
  }

  function mainVariantId() {
    var submit = document.querySelector('.product__info-container .product-form__submit');
    var form = submit && submit.closest('form');
    var input = form && form.querySelector('[name=id]');
    return input ? String(input.value) : null;
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.ss-badge').forEach(function (badge) {
          badge.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('ss:cart-updated', { detail: cart }));
        return cart;
      });
  }

  function applyCode(code) {
    if (!code) return Promise.resolve(true);
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok; })
      .catch(function () { return false; });
  }

  /* Opens the side cart with fresh data so the bundle discount shows right away. Falls back to the cart page. */
  function openCart() {
    if (window.ssCart) {
      window.ssCart.refresh().then(function () { window.ssCart.open(); });
      return;
    }
    window.location = '/cart';
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var currency = root.dataset.currency || 'USD';
    var tiers = parse(root.querySelector('[data-tiers]'), [])
      .filter(function (t) { return t.percent > 0 && t.code; })
      .sort(function (a, b) { return a.min - b.min; });

    var thumbs = root.querySelectorAll('[data-thumb]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ss-item]')).map(function (el, i) {
      return {
        el: el,
        main: el.hasAttribute('data-main'),
        oos: el.hasAttribute('data-oos'),
        thumb: thumbs[i],
        check: el.querySelector('.ss-fbt__check'),
        select: el.querySelector('[data-variant-select]'),
        now: el.querySelector('[data-now]'),
        was: el.querySelector('[data-was]'),
        label: el.querySelector('[data-variant-label]'),
        variants: parse(el.querySelector('[data-variants]'), [])
      };
    });

    /* Sold out extras stay in the layout but never count toward the total, the tier or the cart. */
    var stockCount = items.filter(function (item) { return !item.oos; }).length;

    var noteEl = root.querySelector('[data-note]');
    var totalEl = root.querySelector('[data-total]');
    var totalWasEl = root.querySelector('[data-total-was]');
    var saveEl = root.querySelector('[data-save]');
    var fineEl = root.querySelector('[data-fine]');
    var addBtn = root.querySelector('[data-add]');
    var msg = root.querySelector('[data-msg]');
    var addLabel = addBtn.textContent;
    var state = { tier: null, active: [] };

    function money(cents) {
      try {
        return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: currency });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function variantFor(item) {
      var id = null;
      if (item.main) {
        id = mainVariantId();
      } else if (item.select) {
        id = item.select.value;
      }
      var found = item.variants.filter(function (v) { return String(v.id) === id; })[0];
      return found || item.variants.filter(function (v) { return v.available; })[0] || item.variants[0];
    }

    function tierFor(count) {
      var found = null;
      tiers.forEach(function (t) { if (t.min <= count) found = t; });
      return found;
    }

    function nextTierFor(count) {
      return tiers.filter(function (t) { return t.min > count && t.min <= stockCount; })[0] || null;
    }

    function update() {
      var active = [];
      items.forEach(function (item) {
        if (item.oos) {
          item.variant = null;
          item.active = false;
          return;
        }
        item.variant = variantFor(item);
        item.active = !!(item.check.checked && item.variant && item.variant.available);
        if (item.active) active.push(item);
      });

      var count = active.length;
      var tier = tierFor(count);
      var next = nextTierFor(count);
      var pct = tier ? tier.percent : 0;
      var subtotal = 0;
      var total = 0;

      items.forEach(function (item) {
        if (item.oos) return;
        var v = item.variant;
        var price = v ? v.price : 0;
        var discounted = item.active && pct ? Math.round(price * (100 - pct) / 100) : price;
        if (item.active) {
          subtotal += price;
          total += discounted;
        }
        item.now.textContent = money(discounted);
        item.now.classList.toggle('is-sale', item.active && pct > 0);
        item.was.textContent = money(price);
        item.was.hidden = !(item.active && pct > 0);
        if (item.main && item.label) {
          item.label.textContent = item.variants.length > 1 && v ? v.title : '';
        }
        item.el.classList.toggle('is-off', !item.active);
        if (item.thumb) item.thumb.classList.toggle('is-off', !item.active);
      });

      totalEl.textContent = money(total);
      totalEl.classList.toggle('is-sale', pct > 0);
      totalWasEl.textContent = money(subtotal);
      totalWasEl.hidden = !pct;
      saveEl.hidden = !pct;
      fineEl.hidden = !pct;
      if (pct) saveEl.textContent = 'You save ' + money(subtotal - total) + ' (' + pct + '%)';

      var note = '';
      if (tiers.length) {
        if (tier) {
          note = 'Get ' + tier.percent + '% off when you buy the bundle.';
          if (next) {
            var more = next.min - count;
            note += ' Add ' + more + ' more ' + (more === 1 ? 'item' : 'items') + ' to save ' + next.percent + '%.';
          }
        } else if (next) {
          note = 'Select ' + next.min + ' items to get ' + next.percent + '% off.';
        }
      }
      noteEl.textContent = note;

      addBtn.disabled = count === 0;
      state.tier = tier;
      state.active = active;
    }

    root.addEventListener('change', update);
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.product__info-container')) setTimeout(update, 150);
    });
    document.addEventListener('variant:change', function () { setTimeout(update, 150); });

    addBtn.addEventListener('click', function () {
      var lines = state.active.map(function (item) { return { id: item.variant.id, quantity: 1 }; });
      if (!lines.length) return;
      var code = state.tier ? state.tier.code : '';

      addBtn.disabled = true;
      addBtn.textContent = 'Adding';
      msg.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines })
      })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            msg.textContent = res.data.description || res.data.message || 'Some items could not be added.';
            return;
          }
          return applyCode(code).then(function (applied) {
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              try {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ss-bundle', cartData: res.data });
              } catch (e) {}
            }
            return refreshCart().then(function () {
              if (code && !applied) {
                msg.textContent = 'Your items are in the cart. Enter code ' + code + ' at checkout to get the bundle discount.';
              } else {
                openCart();
              }
            });
          });
        })
        .catch(function () {
          msg.textContent = 'Something went wrong. Please try again.';
        })
        .then(function () {
          addBtn.textContent = addLabel;
          update();
        });
    });

    update();
  }

  function start() {
    document.querySelectorAll('[data-ss-fbt]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();